import Vue from 'vue'
import { Route, RouteConfig } from 'vue-router'
import { RouteConfigSingleView, Position } from 'vue-router/types/router'
import { getTranslateValue } from '@/utils/util'
import getEnv from '@/utils/env'
const env = getEnv()
let mainPath = '/club'
if (env !== 'production') {
  mainPath = '/club-test'
}
interface RouteInterface {
  [index: string]: Array<RouteConfig>
}

interface RouteItem {
  path?: string,
  name?: string,
  module?: string,
  component?: Function,
  beforeEnter?: Function
}

const allRoutes: RouteInterface = {
  index: [
    {
      path: mainPath + '/feed/detail',
      name: 'feed-detail',
      component: () => import(/* webpackChunkName: "chunk-feed-detail" */'../views/feed/Detail.vue'),
      beforeEnter (to: Route, from: Route, next: Function) {
        typeof document !== 'undefined' && (document.title = getTranslateValue('feed_title'))
        console.log('🌟 to, from', to, from)
        next()
      }
    },
    // {
    //   path: mainPath + '/feeds/detailssr',
    //   name: 'feed-detail',
    //   component: () => import(/* webpackChunkName: "chunk-feed-detail" */'../views/feed/Detail.vue'),
    //   beforeEnter (to: Route, from: Route, next: Function) {
    //     typeof document !== 'undefined' && (document.title = getTranslateValue('feed_title'))
    //     console.log('🌟 to, from', to, from)
    //     next()
    //   }
    // },
    {
      path: mainPath + '/topic/detail',
      name: 'topic-detail',
      component: () => import(/* webpackChunkName: "chunk-topic-detail" */'../views/topic/Detail.vue'),
      beforeEnter (to: Route, from: Route, next: Function) {
        typeof document !== 'undefined' && (document.title = getTranslateValue('topic_title'))
        console.log('🌟 to, from', to, from)
        next()
      }
    },
  ],
}

export default allRoutes


export const beforeEach = (currentModuleName: string) => {
  // 找到不是当前模块的所有path
  let otherModulePageNames: Array<object> = []
  for (const moduleName in allRoutes) {
    if (moduleName !== currentModuleName && allRoutes.hasOwnProperty(moduleName)) {
      const routes = allRoutes[moduleName]
      const pageNames = routes.map((item: RouteConfigSingleView) => {
        const includePageName = otherModulePageNames.find((eachOtherModule: RouteItem) => eachOtherModule.path === item.path)
        if (includePageName) {
          console.error('有重复页面：', item)
        }
        return {
          module: moduleName,
          path: item.path,
          name: item.name
        }
      })
      otherModulePageNames = otherModulePageNames.concat(pageNames)
    }
  }
  return async (to: Route, from: Route, next: Function) => {
    console.log('🌟 to, from', to, from)
    // 如果通过router.push 跳转的页面，不在当前模块里
    // 要通过location的方式跳转到对应的页面
    const otherModule: RouteItem | undefined  = otherModulePageNames.find((item: RouteItem) => item.path === to.path || item.name === to.name)
    if (otherModule) {
      if (typeof location !== 'undefined') {
        const redirect = (href: string) => {
          if (from.name === null) {
            location.replace(href)
          } else {
            location.href = href
          }
        }
        let path = to.fullPath
        if (to.matched.length === 0 && to.fullPath === '/') {
          path = `${otherModule.path}`
        }
        const reg = new RegExp(`(${currentModuleName}\.(html)?\/?)$`)
        console.error(reg, location.pathname)
        if (reg.test(location.pathname)) {
          redirect(`${location.origin}${location.pathname.replace(reg, `${otherModule.module}.html`)}#${path}`)
        } else if (location.pathname.slice(-1) === '/') {
          redirect(`${location.origin}${location.pathname}${otherModule.module}.html#${path}`)
        } else {
          redirect(`${location.origin}${location.pathname}/${otherModule.module}.html#${path}`)
        }
        return
      }
    }
    next()
  }
}

export const scrollBehavior = (to: Route, from: Route, savedPosition: void | Position) => {
  const needSavePaths = ['home']
  const toName = to.name as string
  const needSave = needSavePaths.indexOf(toName) !== -1
  if (savedPosition && needSave) {
    return savedPosition
  } else if (!needSave) {
    return { x: 0, y: 0 }
  }
}
